import { Component } from 'js-component-framework';
import AriaPopup from 'js-component-framework/lib/plugins/AriaPopup';

/*
 * Component for popup menus.
 *
 * Expected config:
 *
 *  querySelectorAll: {
 *    menus: [],
 *  },
 *  options: {
 *    subMenuSelector: '',
 *  }
 */
export default class Menu extends Component {
  /**
   * Looks for all anchor tags within the menu that are linked to #.
   * Replaces them with buttons, which are semantically appropriate.
   * @param {object} options.element HTMLElement to search for anchors without
   *                                 links.
   */
  static transformHashesToButtons({ element }) {
    if (! (element instanceof HTMLElement)) {
      return;
    }

    const hasLinks = element.querySelectorAll('a[href="#"]');

    Array.from(hasLinks)
      .forEach((link) => {
        const parent = link.parentNode;
        const button = document.createElement('button');
        button.textContent = link.innerText;
        parent.insertBefore(button, link); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertBefore
        parent.removeChild(link);
      });
  }

  /**
   * Given an array of menus and a submenu to search for, applies the AriaPopup
   * libary to each menu.
   * @param  {array}   options.menus           Menus that contain a controller
   *                                           (first element child) and a
   *                                           target (element that matches
   *                                           subMenuSelector).
   * @param  {string} options.subMenuSelector Selector for target within menu.
   * @return {array}                           Initialized menus.
   */
  static applyPopups({ menus, subMenuSelector }) {
    if (! menus || ! subMenuSelector) {
      return false;
    }

    return Array.from(menus)
      .map((menu) => {
        const controller = menu.firstElementChild;
        const target = menu.querySelector(subMenuSelector);
        return {
          controller,
          target,
        };
      })
      // Only include pairs with targets
      .filter(({ controller, target }) => (controller && target))
      // Apply AriaPopup to all pairs
      .map(({ controller, target }) => new AriaPopup({ controller, target }));
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    /**
     * Initialize variables from configuration
     */
    const {
      children: { menus = [] },
      options: { subMenuSelector = false },
      element,
    } = this;

    // Must run before all other functions as this will destroy any
    // anchor elements in the dom.
    Menu.transformHashesToButtons({ element });

    // Create controller - target relationships with popup menus.
    Menu.applyPopups({ menus, subMenuSelector });
  }
}
